import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../../entity_staff_element_unified_list_items/fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('entity_staff_element_id')
];

const config: IFormConfig = { 
	title: 'Seleziona Personale',
	fields: formFields 
};

export default config;
